import React, { Component } from "react";
import { Table, Card, Row, Button, Image, Col } from "react-bootstrap";
import AddCountry from "./AddCountry";
import EditCountry from "./EditCountry";
import DeleteCountry from "./DeleteCountry";
import ReactPaginate from "react-paginate";
import "./Country.css";
var dateFormat = require("dateformat");

class Country extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAddModel: false,
      showEditModel: false,
      showDelModel: false,
      page: 0,
      perPage: 10,
    };
  }
  componentDidMount() {
    this.props.fetchCountries();
  }

  handleAddCountry = () => {
    this.setState({
      showAddModel: true,
    });
  };
  closeAddModel = () => {
    this.setState({
      showAddModel: false,
    });
  };
  handleEditCountry = (item) => {
    this.setState({
      showEditModel: true,
      ItemList: item,
    });
  };
  closeEditModel = () => {
    this.setState({
      showEditModel: false,
    });
  };
  handleDelCountry = (item) => {
    this.setState({
      showDelModel: true,
      DeleteItem: item,
    });
  };
  closeDelModel = () => {
    this.setState({
      showDelModel: false,
    });
  };

  resetPage = () => {
    this.setState({ page: 0 });
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;
    this.props.countrySelectedPage(selectedPage + 1);
    this.setState({ page: selectedPage });
  };

  render() {
    let p = this.state.page + 1;
    const count = this.props.CountryCount && this.props.CountryCount;
    let countryPageCount = Math.ceil(count / this.state.perPage);

    return (
      <div>
        <Card>
          <Card.Header>
            <Row className="align-items-center w-100 justify-content-between  tableHeaderRow">
              <Col xs={12} sm={6} md={6} lg={6} style={{ margin: "auto" }}>
                <h3>Countries</h3>
              </Col>
              <Col xs={12} sm={6} md={6} lg={6}>
                <div className="countryRecrd">
                  <i className="cui-note icons cmnRecordIcon"></i>
                  <span className="cmnPageCount">
                    {count !== 0 && count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </Card.Header>
          <Card.Body>
            <div>
              <Button
                style={{ marginBottom: "15px" }}
                onClick={() => this.handleAddCountry()}
              >
                <i className="fa fa-plus fa-md"></i>
                <span style={{ marginLeft: "5px", fontWeight: "bold" }}>
                  ADD
                </span>
              </Button>
              <AddCountry
                showAddModel={this.state.showAddModel}
                closeAddModel={this.closeAddModel}
                AddCountry={this.props.AddCountry}
                resetPage={this.resetPage}
              />
            </div>
            <div>
              <Table responsive bordered striped className="cmnMainTable">
                <thead>
                  <tr className="cmnMainTableHd">
                    <th style={{ width: "70px" }}>SL NO</th>
                    <th>NAME</th>
                    <th>ISO NAME</th>
                    <th>ISO3 NAME</th>
                    <th>NICE NAME</th>
                    <th>COUNTRY CALLING CODE</th>

                    <th style={{ width: "100px" }}>ACTIVE</th>
                    <th>CREATED DATE</th>
                    <th style={{ width: "100px" }}>ACTION</th>
                  </tr>
                </thead>
                <tbody>
                  {this.props.CountryList &&
                    this.props.CountryList.map((item, i) => (
                      <tr key={i}>
                        <td>{10 * (p - 1) + i + 1}</td>
                        <td className="cmn_Cap">
                          {item !== null && item.name}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.isoName}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.iso3Name}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.niceName}
                        </td>

                        <td className="cmn_Cap">
                          {item !== null && item.callingCode}
                        </td>

                        <td>{item !== null && item.isActive ? "Yes" : "No"}</td>
                        <td className="cmn_Cap">
                          {item.createdAt !== null &&
                            dateFormat(item.createdAt, "mediumDate")}
                        </td>
                        <td className="cmnViewIcon">
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                            }}
                          >
                            <i
                              className="fa fa-edit fa-lg "
                              onClick={() => this.handleEditCountry(item)}
                            ></i>
                            <EditCountry
                              showEditModel={this.state.showEditModel}
                              closeEditModel={this.closeEditModel}
                              ItemList={this.state.ItemList}
                              EditCountry={this.props.EditCountry}
                              resetPage={this.resetPage}
                            />
                            {/* <i
                              className="fa fa-trash fa-lg"
                              style={{
                                paddingLeft: 10,
                              }}
                              onClick={() => this.handleDelCountry(item)}
                            ></i>
                            <DeleteCountry
                              showDelModel={this.state.showDelModel}
                              closeDelModel={this.closeDelModel}
                              DeleteItem={this.state.DeleteItem}
                              DeleteCountry={this.props.DeleteCountry}
                              resetPage={this.resetPage}
                            /> */}
                          </div>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </Table>

              {(this.props.CountryList === undefined ||
                (this.props.CountryList &&
                  this.props.CountryList.length === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">No Countries Found</div>
                </div>
              )}
            </div>
          </Card.Body>

          {countryPageCount > 1 ? (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                breakClassName={"break-me"}
                pageCount={countryPageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                subContainerClassName={"pages pagination"}
                activeClassName={"active"}
              />
            </div>
          ) : null}
        </Card>
      </div>
    );
  }
}

export default Country;
